import HostApi from "../../settings/HostApi";
import AutomasPeritajeEntity from "../../../domain/entities/AutomasPeritajeEntity";
import { API_URL } from "../../../config/env";

const BASE_URL = API_URL;

/**
 * Trae el peritaje de Automás por placa: `GET /get-car-automas/<placa>/`.
 *
 * Igual que el peritaje de Colserauto, el backend puede devolver tokens no válidos para JSON
 * (NaN / Infinity) cuando un porcentaje no se puede calcular, así que se lee el texto crudo,
 * se sanea a `null` y luego se parsea.
 *
 * Con `strict` un fallo del servicio (5xx, red) lanza en vez de devolver `null`, para distinguir
 * "no tiene peritaje" (404) de "no se pudo consultar".
 */
const GetCarAutomasByPlateApiImpl = async (
    plate: string,
    options?: { strict?: boolean },
): Promise<AutomasPeritajeEntity | null> => {
    try {
        const response = await fetch(`${BASE_URL}/get-car-automas/${encodeURIComponent(plate.trim())}/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: HostApi.getToken(),
            },
        });

        if (!response.ok) {
            if (options?.strict && response.status !== 404) throw new Error(`Automás respondió ${response.status}`);
            return null;
        }

        const text = await response.text();
        const sanitized = text.replace(/\bNaN\b/g, "null").replace(/-?\bInfinity\b/g, "null");

        return JSON.parse(sanitized) as AutomasPeritajeEntity;
    } catch (error) {
        if (options?.strict) throw error;
        return null;
    }
};

export default GetCarAutomasByPlateApiImpl;
